import axios from "axios";
import { useEffect, useState } from "react";
import { baseUrl } from "../config/const";
import Controls from "../components/controls/Controls";
import { Typography, Paper, Toolbar, Box, Link } from "@material-ui/core";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const Absensi = () => {
  const now = new Date(Date.now());
  const [dateRanges, setDateRanges] = useState([
    new Date(now.getFullYear(), now.getMonth(), 1),
    new Date(now.getFullYear(), now.getMonth() + 1, 0),
  ]);
  const [absensiToko, setAbsensiToko] = useState([]);
  const [toko, setToko] = useState("PADM");
  const [listToko, setListToko] = useState([]);

  const columns = [
    {
      field: "staff",
      headerName: "Staff",
      width: 120,
    },
    {
      field: "toko",
      headerName: "Toko",
      width: 120,
    },
    {
      field: "role",
      headerName: "Jabatan",
      width: 175,
    },
    {
      field: "alasan",
      headerName: "Jabatan",
      width: 175,
    },
    {
      field: "tanggal",
      headerName: "Tanggal",
      width: 175,
      valueGetter: (params) =>
        new Date(params.row.tanggal).toLocaleDateString("en-CA"),
    },
  ];

  const getAbsensi = async () => {
    try {
      const {
        data: { data },
      } = await axios.get(`${baseUrl}/getAbsensi`, {
        params: {
          startDate: dateRanges[0].toLocaleDateString("en-CA"),
          endDate: dateRanges[1].toLocaleDateString("en-CA"),
          toko,
        },
      });
      console.log(absensiToko);
      setAbsensiToko(data.map((item, index) => ({ id: index, ...item })));
    } catch (error) {
      console.error(error);
    }
  };

  const getListKasir = async () => {
    try {
      const {
        data: { data },
      } = await axios.get(`${baseUrl}/getAllToko`);

      setListToko(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getAbsensi();
  }, [toko, dateRanges]);

  useEffect(() => {
    getListKasir();
  }, []);

  return (
    <>
      <Typography variant="h3">Absensi Staff Toko</Typography>
      <Paper style={{ height: 600, padding: 20, marginTop: 20 }}>
        <Box style={{ display: "flex" }}>
          <Toolbar style={{ alignItems: "center" }}>
            <Controls.Label label="Pilih Toko: " />
            <Controls.Select
              name="toko"
              value={toko}
              noneLabel={"All"}
              onChange={(e) => {
                setToko(e.target.value);
              }}
              otherStyle={{
                marginBottom: 0,
                marginLeft: 10,
              }}
              options={listToko.map(({ name, role }) => {
                return {
                  id: name,
                  name: name,
                };
              })}
            />
          </Toolbar>
          <Toolbar>
            <Controls.Label label="Select date: " />
            <Box style={{ width: 10 }} />
            <Controls.DateRangeCustomPicker
              name="date-range"
              setDates={setDateRanges}
              dateRanges={dateRanges}
            />
          </Toolbar>
        </Box>
        <Box style={{ marginBottom: 10 }} />
        <DataGrid
          columns={columns}
          rows={absensiToko}
          components={{ Toolbar: GridToolbar }}
          checkboxSelection
          disableSelectionOnClick
          style={{ minHeight: 450, height: "auto" }}
        />
      </Paper>
    </>
  );
};

export default Absensi;
